<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <VeeForm @submit="onSubmit" ref="userFieldForm">
        <modal-form
          v-model="isModalVisible"
          @on-cancel="() => (isModalVisible = false)"
          :title="isEditMode ? `Update ${crudName}` : `Add New ${crudName}`"
          width="40%"
        >
          <template #bodyForm>
            <dynamic-form :schema="formSchema" :formData="formData" />
          </template>
        </modal-form>
      </VeeForm>

      <dynamic-table
        :title="`${crudName}s`"
        :buttonTitle="`New ${crudName}`"
        :pageSize="pageSize"
        :pageNumber="pageNumber"
        :records="records?.data?.data || []"
        :totalRecords="records?.data?.totalRecords || 0"
        :columnDefs="rolesColumns"
        :config="{
          allowEdit: [true, `Edit ${crudName}`],
          allowDelete: [false, `Delete ${crudName}`],
        }"
        @open-modal="handleNewRole"
        @on-change-select="
          (value) => {
            pageNumber = 1;
            pageSize = value;
            getRoles();
          }
        "
        @on-change-page="
          (value) => {
            pageNumber = value;
            getRoles();
          }
        "
        @on-edit-record="handleEdit"
      >
        <template #extraButtons="{ row }">
          <el-tooltip placement="top" content="Assing Permissions">
            <router-link
              class="el-button el-button--danger el-button--small btn-link btn-icon-only is-circle"
              v-tooltip="'Manage Permissions'"
              :to="{
                name: 'Manage Permissions',
                params: { roleId: row.id },
              }"
            >
              <i
                class="ni ni-lock-circle-open text-white text-sm opacity-10"
              ></i
            ></router-link>
          </el-tooltip>
        </template>
      </dynamic-table>
    </div>
  </div>
</template>

<script>
import { Form as VeeForm } from "vee-validate";
import { defineComponent, ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { showAlert } from "@/utils/alerts";

import DynamicTable from "@/components/DynamicTable.vue";
import DynamicForm from "@/components/DynamicForm.vue";
import ModalForm from "@/components/ModalForm.vue";
import { rolesForm as formSchema } from "@/constants/formSchemes";
import { rolesColumns } from "@/constants/tableColumns";

export default defineComponent({
  name: "RoleComponent",
  components: {
    VeeForm,
    ModalForm,
    DynamicForm,
    DynamicTable,
  },

  setup() {
    const store = useStore();
    const isModalVisible = ref(false);
    const isEditMode = ref(false);

    const crudName = "Role";

    //filter variables
    const pageSize = ref(10);
    const pageNumber = ref(1);
    const filter = ref("");

    const formData = ref({
      id: 0,
      name: "",
      description: "",
    });

    const records = computed(() => store.state.roles.rolesResponse);

    onMounted(() => {
      getRoles();
    });

    const getRoles = async () => {
      let params = `?pageSize=${pageSize.value}`;
      params += `&pageNumber=${pageNumber.value}`;
      if (filter.value != "")
        params += `&filter=x.name.contains("${filter.value}") or x.description.contains("${filter.value}")`;
      store.dispatch("roles/getRoles", params);
    };

    const onSubmit = async (values, { resetForm }) => {
      isModalVisible.value = false;
      let action = "";
      let payload = {};
      resetForm();

      if (isEditMode.value) {
        action = "updateRole";
        payload = { ...values, id: formData.value.id };
      } else {
        action = "addRole";
        payload = values;
      }

      await store.dispatch(`roles/${action}`, payload);

      if (store.getters["roles/isTransactionSuccess"]) {
        isEditMode.value
          ? showAlert(
              "Resource has been updated",
              "You can see the resource updated in the list",
              "success",
            )
          : showAlert(
              "Resource has been created",
              "You can see the resource in the list",
              "success",
            );
        await getRoles();
      }
    };

    const handleEdit = (item) => {
      item.isActive = true;
      isModalVisible.value = true;
      isEditMode.value = true;
      Object.assign(formData.value, item);
    };

    const handleNewRole = () => {
      isModalVisible.value = true;
      isEditMode.value = false;
    };

    return {
      getRoles,

      isModalVisible,
      isEditMode,
      crudName,

      //Filter variables
      pageNumber,
      pageSize,
      filter,

      //data
      records,

      formSchema,
      formData,
      rolesColumns,
      onSubmit,
      handleEdit,
      handleNewRole,
    };
  },
});
</script>
